import { createStore } from '@stencil/store';

import { LandingStepByStep, LegalContents, OEMContent } from '../interfaces/interface.landing';
import { DynamicEntryInstallationMode } from '../utils/utils.dynamic-entry';

const initialState = {
  offerCode: '',
  dealerId: '00000000-0000-0000-0000-000000000000',
  assignedMainTitleSubCopy: '',
  assignedMainTitleHeader: '',
  assignedMainImageDealershipPhone: '',
  assignedMainImageDealershipName: '',
  assignedMainImageTitleImage: '',
  assignedStepByStep: {} as LandingStepByStep,
  unassignedMainTitleSubCopy: '',
  unassignedMainTitleHeader: '',
  unAssignedStepByStep: {} as LandingStepByStep,
  faqData: '',
  faqTitle: '',
  videoComponent: {},
  contactUsComponent: {},
  installationMode: DynamicEntryInstallationMode.Redirect,
  legalContents: {} as LegalContents,
  oem: {} as OEMContent,
  isCombined: false,
  isAssignedOffer: false,
  dealerGroupId: '',
  cobrandingGroupId: '',
};

const { state, on, onChange, reset } = createStore(initialState);

export { initialState, on, onChange, state, reset };
export default state;
